
export default {
  name: 'checkbox-button-group',
}
